import React from 'react';
import { Card, Statistic, Grid, Icon } from 'semantic-ui-react';
import { renderUSD, renderCNY } from '../helpers/render';

const BalanceCard = ({ balanceUSD, balanceCNY, usedAmountUSD, usedAmountCNY, showUsed = false }) => {
  return (
    <Card fluid>
      <Card.Content>
        <Card.Header>
          <Icon name='dollar sign' />
          账户余额
        </Card.Header>
      </Card.Content>
      <Card.Content>
        <Grid columns={2} divided>
          <Grid.Column textAlign='center'>
            <Statistic size='small'>
              <Statistic.Value style={{ color: '#21ba45' }}>
                {renderCNY(balanceCNY)}
              </Statistic.Value>
              <Statistic.Label>人民币余额</Statistic.Label>
            </Statistic>
            {showUsed && (
              <div style={{ marginTop: '10px', fontSize: '0.9em', color: '#666' }}>
                已使用: {renderCNY(usedAmountCNY)}
              </div>
            )}
          </Grid.Column>
          <Grid.Column textAlign='center'>
            <Statistic size='small'>
              <Statistic.Value style={{ color: '#2185d0' }}>
                {renderUSD(balanceUSD)}
              </Statistic.Value>
              <Statistic.Label>美元余额</Statistic.Label>
            </Statistic>
            {showUsed && (
              <div style={{ marginTop: '10px', fontSize: '0.9em', color: '#666' }}>
                已使用: {renderUSD(usedAmountUSD)}
              </div>
            )}
          </Grid.Column>
        </Grid>
      </Card.Content>
    </Card>
  );
};

export default BalanceCard;
